export default __webpack_public_path__ + "static/316-c57a9a27f3bcfc78aa35d0c88ad826f9.gif";